import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import ClinicianForm from './ClinicianForm';

export default function NewClinician() {
  return (
    <ScreenWrap>
      <Stack gap={3}>
        <Stack gap={1}>
          <HeaderBreadcrumbs
            title="Create New Clinician"
            items={[{ name: 'Clinicians', url: '/clinicians' }]}
          />
        </Stack>

        <ClinicianForm />
      </Stack>
    </ScreenWrap>
  );
}
